var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 54.25,
    viewBox: "0 0 62 54.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warningsign",
    d: "M62,50.375A3.775,3.775,0,0,1,60.881,53.1a3.694,3.694,0,0,1-2.756,1.15H3.875A3.7,3.7,0,0,1,1.119,53.1,3.766,3.766,0,0,1,0,50.375a3.7,3.7,0,0,1,.544-1.937L27.125,3.875q.484-1.09.7-1.454T28.548,1.3a2.893,2.893,0,0,1,1.09-1.03A3.125,3.125,0,0,1,31,0a2.768,2.768,0,0,1,1.786.606,4.6,4.6,0,0,1,1.15,1.3,20.742,20.742,0,0,1,.939,1.967L61.456,48.438A3.705,3.705,0,0,1,62,50.375Zm-27.125-31a3.875,3.875,0,1,0-7.75,0V31a3.875,3.875,0,0,0,7.75,0ZM30.969,38.75a3.822,3.822,0,0,0-3.844,3.844,3.875,3.875,0,1,0,7.75,0,3.658,3.658,0,0,0-1.15-2.725A3.812,3.812,0,0,0,30.969,38.75Z",
    fill: "#fdb944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningsign);
export default __webpack_public_path__ + "static/media/warningsign.450d5881559bf9f4745ac0f4e0a46907.svg";
export { ForwardRef as ReactComponent };